import React from "react";
import { Container } from "reactstrap";

export default function TermsSections() {
    return (
        <Container className="termsconditions-container terms-content">
            {/* Overview */}
            <section id="overview" className="mb-5 terms-section">
                <h2 className="text-primary">Overview</h2>
                <p>Welcome to Midamas LLP. By accessing or using our website midamasjewellery.net (the “Website”), you agree to comply with and be bound by these Terms & Conditions. Please read them carefully.</p>
               
                <hr style={{ width: "100%", borderTop: "2px solid #ccc", marginTop: "1rem" }} />
            </section>

            {/* Section 1 */}
            <section id="online-store-terms" className="mb-5 terms-section">
                <h2 className="text-primary">1. Use of the Website</h2>
                <p>The Website is intended for retailers, wholesalers, and authorized buyers of jewellery.</p>
                <p>You agree not to misuse the Website or use it for unlawful purposes.</p>
            </section>

            {/* Section 2 */}
            <section id="general-conditions" className="mb-5 terms-section">
                <h2 className="text-primary">2. Intellectual Property</h2>
                <p>All content, designs, images, logos, and text on this Website are the property of Midamas LLP.</p>
                <p>You may not copy, reproduce, or distribute any content without prior written consent.</p>
            </section>

            {/* Section 3 */}
            <section id="accuracy-information" className="mb-5 terms-section">
                <h2 className="text-primary">3. Product Information</h2>
                <p>The Website showcases our jewellery collections for viewing purposes only.</p>
                <p>Prices are not displayed online as our sales are B2B (Business-to-Business).</p>
                <p>While we make every effort to ensure accuracy, we do not guarantee that product descriptions or images are error-free.</p>
            </section>

            {/* Section 4 */}
            <section id="modifications-prices" className="mb-5 terms-section">
                <h2 className="text-primary">4. Limitation of Liability</h2>
                <p>We are not liable for any direct, indirect, or consequential loss arising from the use of our Website.</p>
                <p>The Website may contain links to third-party sites. We are not responsible for their content or practices.</p>
            </section>

            {/* Section 5 */}
            <section id="products-services" className="mb-5 terms-section">
                <h2 className="text-primary">5. Governing Law</h2>
                <p>These Terms & Conditions shall be governed by the laws of India.</p>
                <p>Any disputes will be subject to the exclusive jurisdiction of the courts in <strong>Mumbai, Maharashtra, India.</strong></p>
            </section>

            {/* Section 6 */}
            <section id="billing-account" className="mb-5 terms-section">
                <h2 className="text-primary">6. Amendments</h2>
                <p>We reserve the right to update or modify these Terms & Conditions at any time. Updates will be posted on this page.</p>
            </section>

        </Container>
    );
}
